
<!-- <div class="card spinner-container" *ngIf="loading">
    <p-progressSpinner></p-progressSpinner>
</div> -->

<!-- <div class="content" [ngClass]="{ 'blur': loading }">
    <ng-content></ng-content>
  </div> -->
  
  <div class="spinner-container" *ngIf="loading">
    <div class="card">
      <p-progressSpinner [style]="{width: '150px', height: '150px'}"></p-progressSpinner>
    </div>
  </div>